module.exports = __webpack_public_path__ + "img/francisco-silva.01f709ac.png";